import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import FileDownload from '@material-ui/icons/GetApp';

import QIconButton from 'components/QIconButton';
import QButton from 'components/QButton';
import QCurrency from 'components/QCurrency';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import FastCatIcon from '@material-ui/icons/FlashOn';
import AddIcon from '@material-ui/icons/Add';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import SearchBox from 'components/SearchBox';
import QDialogs from 'components/QDialogs';
import FileImportDialog from 'components/Dialogs/FileImportDialog';
import { getFeatureFlag } from 'utils/featureFlags/selectors';

import { isMobile, isTablet } from 'react-device-detect';
import { isCashAccount } from 'data/accounts/selectors';

import ScheduleViewMenu from './scheduleViewMenu';

import { txnListMetrics } from '../helpers';
import { styles } from './styles';

// ==============================================================
//
// The control bar at the top of the Transaction list (register)
//
// props:
//
// onAdd   - called when add/new transaction pushed
//
//
export class RegControlBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      activeSearch: props.filter && (props.filter.trim().length > 0),
      numTxns: this.numTxns(props.acctTxns),
      showHelp: false,
      showFileImportDialog: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.acctTxns !== this.props.acctTxns) {
      const numTxns = this.numTxns(nextProps.acctTxns);
      this.setState({ numTxns });
    }
    if (nextProps.filter !== this.props.filter) {
      this.setState({ activeSearch: nextProps.filter && (nextProps.filter.trim().length > 0) });
    }
  }

  numTxns = (acctTxns) => {

    const metrics = txnListMetrics(acctTxns);
    return metrics.numTxns;

  };

  onSearch = (string) => {
    if (string !== null) {
      this.setState({ activeSearch: string.trim().length > 0 });
      this.props.onSearch(string.trim());
    }
  };

  downloadFile = () => {
    if (this.props.downloadFile) {
      this.props.downloadFile();
    }
  };

  render() {

    const { classes, onFastCategorize, scheduledTransactionsInRegister, accountsFilter, csvImport } = this.props;

    // If searching
    const { numTxns, sumTxns } = this.props.transactionListMetrics;
    const currSymbol = this.props.getSharedCurrency(this.props.acctTxns);
    const totalText = this.props.formatAmount(sumTxns, currSymbol);
    const selText = ` ${numTxns} Transaction${numTxns > 1 ? 's' : ''} Found  (${totalText})`;

    return (
      <>
        {this.state.showHelp && this.searchRef &&
          <SearchHelpBox
            classes={classes}
            anchorEl={this.searchRef}
            onClose={() => this.setState({ showHelp: false })}
          />
        }
        <div className={classes.container} >
          <Typography className={classes.title} variant="h6">
            Transaction Activity
          </Typography>

          <div className={classes.searchContainer} ref={(x) => { this.searchRef = x }}>
            {!this.props.noNew &&
              <QButton
                variant="contained"
                id="txn-register-add-txn-button"
                className={classes.addTxnButton}
                aria-label="Add"
                onClick={(e) => {
                  e.stopPropagation();
                  if (this.props.showDebtErrorMessage) {
                    this.props.dialogAlert(
                      'Unsupported Feature',
                      'You may only add, modify or delete loan account transactions on the desktop app',
                      undefined,
                      ['OK'],
                    );
                    return;
                  }
                  this.props.showNewTxn();
                }}
              >
                <AddIcon/> ADD
              </QButton>
            }

            {csvImport
              && accountsFilter && accountsFilter.size === 1 && isCashAccount(accountsFilter.first()) &&
            <>
              <QButton
                variant="outlined"
                id="txn-register-import-button"
                className={classes.addTxnButton}
                aria-label="Add"
                onClick={(_e) => {
                  this.setState({showFileImportDialog: true});
                }}
              >
                <CloudUploadOutlinedIcon/>&nbsp; IMPORT
              </QButton>

              <FileImportDialog
                account={accountsFilter.first()}
                open={Boolean(this.state.showFileImportDialog)}
                onHandleClose={() => this.setState({showFileImportDialog: false})}
              />
            </>
            }

            {scheduledTransactionsInRegister &&
              <div className={classes.scheduleMenuHolder}>
                {this.props.onReminderChange &&
                  <ScheduleViewMenu
                    reminderSetting={this.props.reminderSetting}
                    onChange={this.props.onReminderChange}
                    isWindows={this.props.isWindowsDataset}
                  />
                }
              </div>
            }
            {onFastCategorize &&
              <QIconButton
                aria-label="Categorize transactions"
                id="reg-fast-categorize-all"
                IconComponent={FastCatIcon}
                onClick={onFastCategorize}
                tooltip="Automatically categorize uncategorized transactions when a suggestion is available"
                size="small-target"
              />
            }
            {this.state.activeSearch &&
              <Typography id="reg-header-search-total" className={classes.searchMetrics}>
                {selText}
              </Typography>
            }
            <SearchBox
              onSearch={this.onSearch}
              initialValue={this.props.filter}
              autoSearch={this.props.autoSearch}
              collapsable
              onHelp={(show) => this.setState({ showHelp: show })}
            />
            {this.state.activeSearch && (this.state.numTxns > 0) && !(isMobile || isTablet) &&
            <QIconButton
              aria-label="Download transactions"
              id="reg-fast-download-csv"
              IconComponent={FileDownload}
              onClick={this.downloadFile}
              tooltip="Download transactions to a CSV file"
              size="small-target"
            />
            }
          </div>
        </div>
      </>
    );
  }
}

RegControlBar.propTypes = {
  onFastCategorize: PropTypes.func,
  onSearch: PropTypes.func,
  autoSearch: PropTypes.bool,
  downloadFile: PropTypes.func,
  filter: PropTypes.string,
  accountsFilter: PropTypes.object,
  acctTxns: PropTypes.object,
  transactionListMetrics: PropTypes.object,
  scheduledTransactionsInRegister: PropTypes.bool,
  reminderSetting: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onReminderChange: PropTypes.func,
  noNew: PropTypes.bool,
  showNewTxn: PropTypes.func.isRequired,
  isWindowsDataset: PropTypes.bool,
  csvImport: PropTypes.bool,

  classes: PropTypes.object,

  // QCurrency
  getSharedCurrency: PropTypes.func,
  formatAmount: PropTypes.func,

  // DEBT NOT SUPPORTED IN QUICKEN WEB
  showDebtErrorMessage: PropTypes.bool,

  // QDialogs
  dialogAlert: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    csvImport: getFeatureFlag(state, 'csvImport'),
  };
}

export default compose(
  withStyles(styles),
  QCurrency(),
  QDialogs(),
)(connect(mapStateToProps)(RegControlBar));

/*
 * Title Header sub component
 */
export const SearchHelpBox = (props) => {

  const { classes, anchorEl, onClose } = props;

  return (
    <Popover
      id="search-help-popover"
      open
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <div className={classes.searchHelpContainer}>
        <Typography className={classes.searchHelpTitle} variant="h6"> Search Tips </Typography>
        <Typography className={classes.searchHelpSubtitle} variant="subtitle1"> Searching for Amounts </Typography>
        <Typography className={classes.helpText} variant="body2"> {`Amount searches that start with '-' or '+' will restrict to expenses or income`}</Typography>
        <Typography className={classes.helpText} variant="body2"> {'"23" will search for 23.00 or -23.00'} </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"-23.50" will search for -23.50'} </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"-23ish" will search for values roughly around -23.00'}  </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"~-23" will also search for values roughly around -23.00'} </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"+>1000" will search for income transactions greater than 1000.00'} </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"+<1000" will search for income transactions less than 1000.00'} </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"-&50,100" will search for expense transactions between 50.00 and 100.00'} </Typography>
        <Typography className={classes.searchHelpSubtitle} variant="subtitle1"> Searching for Dates </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"02/03/2020" will search for transactions dated 02/03/2020'}  </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"Feb 03, 2020" will search for transactions dated 02/03/2020'}  </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"February 03, 2020" will search for transactions dated 02/03/2020'}  </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"02/03/2020ish" will search for transactions dated around 02/03/2020'}  </Typography>
        <Typography className={classes.helpText} variant="body2"> {'">02/03/2020" will search for transactions on or past 02/03/2020'}  </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"<02/03/2020" will search for transactions on or before 02/03/2020'}  </Typography>
        <Typography className={classes.helpText} variant="body2"> {'"&02/03/2020, 03/10/2020" will search for transactions between 02/03 and 03/10/2020'}  </Typography>

      </div>
    </Popover>
  )
};
SearchHelpBox.propTypes = {
  classes: PropTypes.object,
  onClose: PropTypes.func,
  anchorEl: PropTypes.object,
};
